var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7655 14H8.7345C8.054 14 7.5 13.446 7.5 12.7655V7.7345C7.5 7.054 8.054 6.5 8.7345 6.5H12.7655C13.446 6.5 14 7.054 14 7.7345V12.7655C14 13.446 13.446 14 12.7655 14ZM8.7345 7.5C8.605 7.5 8.5 7.605 8.5 7.7345V12.7655C8.5 12.895 8.605 13 8.7345 13H12.7655C12.895 13 13 12.895 13 12.7655V7.7345C13 7.605 12.895 7.5 12.7655 7.5H8.7345Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7655 5.5H8.7345C8.054 5.5 7.5 4.946 7.5 4.2655V1.2345C7.5 0.554 8.054 0 8.7345 0H12.7655C13.446 0 14 0.554 14 1.2345V4.2655C14 4.946 13.446 5.5 12.7655 5.5ZM8.7345 1C8.605 1 8.5 1.105 8.5 1.2345V4.2655C8.5 4.395 8.605 4.5 8.7345 4.5H12.7655C12.895 4.5 13 4.395 13 4.2655V1.2345C13 1.105 12.895 1 12.7655 1H8.7345Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2655 7.5H1.2345C0.554 7.5 0 6.946 0 6.2655V1.2345C0 0.554 0.554 0 1.2345 0H5.2655C5.946 0 6.5 0.554 6.5 1.2345V6.2655C6.5 6.946 5.946 7.5 5.2655 7.5ZM1.2345 1C1.105 1 1 1.105 1 1.2345V6.2655C1 6.395 1.105 6.5 1.2345 6.5H5.2655C5.395 6.5 5.5 6.395 5.5 6.2655V1.2345C5.5 1.105 5.395 1 5.2655 1H1.2345Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2655 14H1.2345C0.554 14 0 13.446 0 12.7655V9.7345C0 9.054 0.554 8.5 1.2345 8.5H5.2655C5.946 8.5 6.5 9.054 6.5 9.7345V12.7655C6.5 13.446 5.946 14 5.2655 14ZM1.2345 9.5C1.105 9.5 1 9.605 1 9.7345V12.7655C1 12.895 1.105 13 1.2345 13H5.2655C5.395 13 5.5 12.895 5.5 12.7655V9.7345C5.5 9.605 5.395 9.5 5.2655 9.5H1.2345Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewTabIcon);
export default __webpack_public_path__ + "static/media/overview-tab-icon.520c0dbd3f3a9eae1a4c24b6346598be.svg";
export { ForwardRef as ReactComponent };